import Blur from "../../api/model/snapshots/layers/Blur";

function equals(blur: Blur, otherBlur: Blur) {
    return blur.type === otherBlur.type && blur.radius === otherBlur.radius;
}

export { equals };
